import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {Toggle} from '../../../../../libs/shared/ui/src/components/booleanInputs/toggle';
import {ChannelComposeModesEnum} from '../../../../models/api/channelBehaviorsModel';
import {ChannelCustomModel} from '../../../../models/api/channelModel';
import {SettingsFieldLine} from '../../../common/settingsFieldLine';
import {SettingsCommonChannelFieldProps} from '../settingsCommonChannelFields';

/*
 * Props.
 */

interface ChannelComposeModeToggleFieldProps extends SettingsCommonChannelFieldProps<ChannelCustomModel> {}

/*
 * Component.
 */

export const ChannelComposeModeToggleField: FC<ChannelComposeModeToggleFieldProps> = (props) => {
  const value = props.edited.preferences.composeMode;

  return (
    <SettingsFieldLine
      title={<Trans id="settingschannel-composemodetoggle-title">Allow new messages from channel</Trans>}
      subtitle={
        <Trans id="settingschannel-composemodetoggle-subtitle">
          Give users ability to compose new messages from this channel
        </Trans>
      }
      content={
        <Toggle
          isChecked={value === ChannelComposeModesEnum.NORMAL}
          onChange={(newValue) => {
            props.onPreferencesChange({
              composeMode: newValue ? ChannelComposeModesEnum.NORMAL : ChannelComposeModesEnum.UNSUPPORTED,
            });
          }}
        />
      }
    />
  );
};
